import { Flex, Result } from "@/base/components/index";
import { SupervisorGuard } from "@/components/supervisor-guard/components/supervisor-guard";
import { useContextDataTable } from "../context/index";
import { LocalizationText } from "@/app/index";
import DataTableNotFoundSvg from "../static/data-table-not-found.svg?react";

export const DataTableEmpty = () => {
  const { emptyResult, actions } = useContextDataTable();

  return (
    <Result
      title={
        emptyResult?.title || (
          <LocalizationText value="composite.data.table.result.title" />
        )
      }
      subTitle={
        emptyResult?.description || (
          <LocalizationText value="composite.data.table.result.description" />
        )
      }
      icon={emptyResult?.icon || <DataTableNotFoundSvg />}
      extra={
        <SupervisorGuard>
          <Flex gap={12} justify="center">
            {actions}
          </Flex>
        </SupervisorGuard>
      }
    />
  );
};
